import React, { useState } from 'react';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { D1, FONT, d1 } from '../design/tokens';
import { GeoLogo } from '../design/GeoLogo';
import { auth } from '../firebase/config';
import { PrivacyPolicy } from './PrivacyPolicy';

// Whitelist da conta docente — só esta conta pode entrar como professora
const TEACHER_EMAIL = 'profalauravalencia@gmail.com';

export function TeacherLogin({ onLogin, onBack }: { onLogin:()=>void; onBack:()=>void }) {
  const [email, setEmail] = useState(TEACHER_EMAIL);
  const [senha, setSenha] = useState("");
  const [showSenha, setShowSenha] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  const handleLogin = async () => {
    const emailNorm = email.trim().toLowerCase();
    if (!emailNorm || !senha) { setErr("Preencha email e senha."); return; }
    // Whitelist: apenas a conta da docente
    if (emailNorm !== TEACHER_EMAIL) { setErr("Acesso permitido apenas a conta da docente."); return; }
    setLoading(true); setErr("");
    try {
      const result = await signInWithEmailAndPassword(auth, emailNorm, senha);
      if (result.user.email !== TEACHER_EMAIL) {
        await signOut(auth);
        setErr("Acesso permitido apenas a conta da docente.");
        setLoading(false);
        return;
      }
      onLogin();
    } catch (e: any) {
      const code = e?.code || '';
      if (code === 'auth/wrong-password' || code === 'auth/invalid-credential') { setErr("Senha incorreta."); }
      else if (code === 'auth/user-not-found') { setErr("Conta nao encontrada. Verifique o cadastro no Firebase."); }
      else if (code === 'auth/invalid-email') { setErr("Email invalido."); }
      else if (code === 'auth/too-many-requests') { setErr("Muitas tentativas. Aguarde alguns minutos."); }
      else if (code === 'auth/user-disabled') { setErr("Conta desativada."); }
      else { setErr("Falha no login. Tente novamente."); }
      setLoading(false);
    }
  };

  return (
    <>
      {showPrivacy && <PrivacyPolicy onClose={() => setShowPrivacy(false)} />}
      <div style={{ minHeight: "100vh", background: D1.paper, fontFamily: FONT.sans, display: "flex", flexDirection: "column" }}>
        <div style={{ background: D1.acc, color: "#fff", fontSize: 11, letterSpacing: 0.6, padding: "6px 32px" }}>GEO Frequência</div>
        <div style={{ flex: 1, display: "grid", placeItems: "center", padding: "24px 16px" }}>
          <div style={{ width: "100%", maxWidth: 400, background: "#fff", border: `1px solid ${D1.line}`, padding: "36px 40px", boxSizing: "border-box" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 26, paddingBottom: 20, borderBottom: `1px solid ${D1.line2}` }}>
              <GeoLogo size={44} />
              <div>
                <div style={{ fontFamily: FONT.serif, fontSize: 22, fontWeight: 600, lineHeight: 1.2 }}>GEO Frequência</div>
                <div style={{ ...d1.cap, fontSize: 10 }}>Registro de frequência discente</div>
              </div>
            </div>
            <h1 style={{ ...d1.h1, fontSize: 26, marginBottom: 6 }}>Acesso docente</h1>
            <div style={{ fontSize: 13, color: D1.ink2, marginBottom: 22 }}>Entre com a conta institucional autorizada.</div>
            <label htmlFor="teacher-email" style={{ ...d1.cap, display: "block", marginBottom: 6 }}>E-mail</label>
            <input
              id="teacher-email"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === "Enter" && (document.getElementById("teacher-pw") as HTMLInputElement)?.focus()}
              style={{ ...d1.inp, marginBottom: 14 }}
            />
            <label htmlFor="teacher-pw" style={{ ...d1.cap, display: "block", marginBottom: 6 }}>Senha</label>
            <div style={{ position: "relative", marginBottom: err ? 8 : 22 }}>
              <input
                id="teacher-pw"
                type={showSenha ? "text" : "password"}
                value={senha}
                onChange={e => setSenha(e.target.value)}
                onKeyDown={e => e.key === "Enter" && handleLogin()}
                style={{ ...d1.inp, paddingRight: 70 }}
              />
              <button type="button" onClick={() => setShowSenha(v => !v)} style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: D1.ink3, fontSize: 12, padding: 0 }}>{showSenha ? "Ocultar" : "Mostrar"}</button>
            </div>
            {err && <div style={{ fontSize: 13, color: D1.alert, marginBottom: 16 }}>{err}</div>}
            <button onClick={handleLogin} disabled={loading} style={{ ...d1.btn, width: "100%", padding: 12, opacity: loading ? 0.6 : 1, cursor: loading ? "not-allowed" : "pointer" }}>
              {loading ? "Entrando…" : "Entrar"}
            </button>
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 18, fontSize: 12.5, gap: 12, flexWrap: "wrap" }}>
              <button onClick={onBack} style={{ ...d1.link, fontSize: 12.5 }}>Sou aluno(a) →</button>
              <button onClick={() => setShowPrivacy(true)} style={{ background: "none", border: "none", cursor: "pointer", color: D1.ink3, fontSize: 12.5, textDecoration: "underline", padding: 0, fontFamily: FONT.sans }}>Política de Privacidade (LGPD)</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
